// Dashboard.js
import React, { useState, useEffect } from "react";
import styles from "./Dashboard.module.scss";
import Header from "../header/header";
import NotificationBanner from "./notificationBanner";
import StatsWidgets from "./statsWidgets";
import ActivityFeed from "./activityFeed";
import { useAuth } from "../../Context/AuthContext";
import WatchList from "./watchlist";
import RecentActivity from "./recentActivity";

export default function Dashboard() {
  const { isAdmin, isSuperAdmin } = useAuth();
  const [loadingStats, setLoadingStats] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await fetchCounts();
      setLoadingStats(false);
    };
    fetchData();
  }, []);

  const fetchCounts = async () => {
    // Simulated async function – replace with your actual logic
    await new Promise((resolve) => setTimeout(resolve, 2000));
  };

  return (
    <div className={styles.container}>
      <Header />
      {/* Display NotificationBanner below the header */}
      <NotificationBanner />

      {!isAdmin() && !isSuperAdmin() && (
        <>
          <WatchList />
          <RecentActivity />
        </>
      )}

      {(isAdmin() || isSuperAdmin()) && (
        <>
          {loadingStats ? (
            <div>Loading...</div>
          ) : (
            <>
              <StatsWidgets />
              <WatchList/>
              <ActivityFeed />
              <RecentActivity />
            </>
          )}
        </>
      )}
    </div>
  );
}
